<script>
  export let emoji;
  export let styles = "";
</script>

<img src="/images/emojis/{emoji}.png" style={styles} alt={emoji} />

<style>
  img {
    position: absolute;
    width: 80px;
    user-select: none;
  }

  @media screen and (max-width: 568px) {
    img {
      width: 50px;
    }
  }
</style>
